import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useScrolled from "../hooks/useScrolled";
import Header from "../components/Header";
import Hero2 from "../sections/Hero2";
import ServicesSection from "../sections/ServicesSection";
import AboutSection from "../sections/AboutSection";
import PortfolioSection from "../sections/PortfolioSection";
import FaqSection from "../sections/FaqSection";
import CtaBand from "../sections/CtaBand";
import LeadForm from "../components/LeadForm";
import Footer from "../components/Footer";
import Reveal from "../components/Reveal";

export default function HomePage() {
  const scrolled = useScrolled();
  const location = useLocation();

  // Доскролл к секции при переходе с хешем (например, /#about с другой страницы).
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    const t = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 60);
    return () => clearTimeout(t);
  }, [location]);

  return (
    <>
      <Header theme="light" visible={scrolled} />
      <div className="page-enter">
        <Hero2 scrolled={scrolled} />
        <Reveal><ServicesSection /></Reveal>
        <Reveal><CtaBand variant="light" /></Reveal>
        <Reveal><AboutSection /></Reveal>
        <Reveal><PortfolioSection /></Reveal>
        <Reveal fadeOnly><FaqSection /></Reveal>
        <LeadForm />
        <Footer />
      </div>
    </>
  );
}
